import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import { Button } from "@nextui-org/react";
import { signout } from "../../redux/actions";
// import image404 from "../../assets/images/404.webp";

const NoMatchPage = () => {
  const { t } = useTranslation();
  const { auth } = useSelector((state) => state.auth.auth);

  const navigate = useNavigate();

  // const navigate = useNavigate();
  // const location = useLocation();

  // const dispatch = useDispatch();

  const handleOnClickBackToHome = () => {
    if (auth?.uid) {
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="w-full h-screen bg-gray-100 flex justify-center items-center">
      <div className="flex max-w-5xl items-center">
        <div className="w-full flex flex-col gap-y-6">
          <h1 className="text-gray-700 text-2xl md:text-4xl font-semibold">Oops...</h1>
          <h1 className="text-gray-700 text-2xl md:text-4xl font-extralight">
            {t("Page not found")}
          </h1>
          <p className="text-sm text-gray-500">
            {t(
              "We are very sorry for the inconvenience. You are trying to access a page that either has been removed or never existed"
            )}
          </p>
          <Button
            size="xl"
            className="rounded w-auto bg-primary p-3 px-6 self-start mt-6 text-sm text-white flex space-x-1"
            onPress={handleOnClickBackToHome}
          >
            <BiLeftArrowAlt className="w-5 h-5" />
            <span>{t("Back to home")}</span>
          </Button>
        </div>
        {/* <img
          src={image404}
          width="auto"
          height="auto"
          className="w-full max-w-2xl h-auto"
          alt="not matched page"
        /> */}
      </div>
    </div>
  );
};

export default NoMatchPage;
